// Hub page content for the Student & Graduate group.
// Sourced from docs/research/australian-visa-pathways.md §5 and §6.

const studentGraduateHub = {
  groupSlug: "student-graduate",
  eyebrow: "Student & Graduate",
  heading: "Student and graduate visas",
  intro:
    "Australia is one of the world's leading study destinations, and study can be the start of a much longer journey. We support you across the whole student lifecycle: choosing a course, preparing your documentation, staying organised, and moving on to a graduate visa and beyond. The regulated migration advice and the visa lodgement are handled by a registered migration agent we match you with. We are honest that study is an expensive, indirect route to staying long term.",

  howItWorks: {
    heading: "How the student journey works",
    steps: [
      {
        title: "Choose a course",
        detail:
          "You enrol in a registered (CRICOS) course that genuinely fits your goals.",
      },
      {
        title: "Get your student visa",
        detail:
          "You apply for the Subclass 500, showing genuine study intentions and financial capacity.",
      },
      {
        title: "Study and stay compliant",
        detail:
          "You maintain enrolment, progress, and health cover, extending your visa if needed.",
      },
      {
        title: "Graduate and progress",
        detail:
          "A graduate (485) visa gives you time to build toward skilled or employer-sponsored options.",
      },
    ],
  },

  atAGlance: {
    heading: "Compare the student and graduate services",
    columns: ["Service", "Best for", "Type", "Leads to"],
    rows: [
      {
        serviceSlug: "student-500",
        cells: [
          "Student (500)",
          "Studying full time in Australia",
          "Temporary visa",
          "Graduate visa and beyond",
        ],
      },
      {
        serviceSlug: "student-visa-extension",
        cells: [
          "Student Visa Extension",
          "Continuing or progressing study",
          "New Subclass 500",
          "Ongoing study",
        ],
      },
      {
        serviceSlug: "graduate-485",
        cells: [
          "Graduate (485)",
          "Working after you finish study",
          "Temporary visa",
          "Skilled or sponsored routes",
        ],
      },
      {
        serviceSlug: "admissions",
        cells: [
          "Admissions",
          "Choosing the right course and provider",
          "Education service",
          "A Confirmation of Enrolment",
        ],
      },
    ],
  },

  faqs: [
    {
      q: "Can studying in Australia lead to permanent residence?",
      a: "Sometimes, but not directly and never guaranteed. A student visa is temporary. Many people move from study to a graduate (485) visa and then to skilled or employer-sponsored visas. We are upfront that this is an indirect, multi-step path, and a registered migration agent advises on the pathway that fits your situation.",
    },
    {
      q: "Do you help with both the course and the visa?",
      a: "Yes, in the parts that are ours. Our admissions support helps you find and apply to a CRICOS-registered course and prepares your documentation, and we match you with a registered migration agent who gives the migration advice and lodges the student visa, so the two stay aligned and consistent.",
    },
    {
      q: "What is the Genuine Student requirement?",
      a: "It is the test that you genuinely intend to study, which replaced the older Genuine Temporary Entrant requirement. Your course choice and study plan need to make sense, which is why getting admissions right matters for the visa.",
    },
  ],

  lastVerified: "13 July 2026",
};

export default studentGraduateHub;
